/* Desayunos del Cielo · Ventana de WhatsApp.
   - Disparadores (2026-10-29): X segundos de navegación ACTIVA (pestaña visible y la persona tocó, movió o
     desplazó la página en los últimos 15 s; 40 s por defecto) o intención de salida (solo escritorio).
     Ya no se abre por scroll (1.414 vistas, 525 cierres, 20 clics). Nunca encima del configurador visible
     o en uso: espera a que deje de estarlo.
   - Frecuencia: máx. N por semana; nunca si ya escribió por WhatsApp (14 días) o lo cerró hoy.
   - Mensaje corto con el producto, sin códigos en el chat. Eventos GA4/Ads (el código interno solo viaja a Analytics):
       ddc_wa_popup_view, ddc_wa_popup_close, whatsapp_click (ubicacion=ventana_whatsapp, wa_ref, origen_trafico).
   Sin dependencias. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ddc-wapop]');
  if (!root || window.__ddcWaPop) return;
  window.__ddcWaPop = true;

  var LS = window.localStorage;
  var K = { shows: 'ddc_wapop_shows', closed: 'ddc_wapop_closed', clicked: 'ddc_wa_clicked', ref: 'ddc_wa_ref', src: 'ddc_first_src' };
  var DAY = 864e5, now = Date.now();
  function get(k) { try { return JSON.parse(LS.getItem(k)); } catch (e) { return null; } }
  function set(k, v) { try { LS.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function gtagEv(name, params) {
    params = params || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
  }

  /* ---------- Origen del tráfico (primer toque de la sesión, se guarda 30 días) ---------- */
  var qs = new URLSearchParams(location.search);
  var src = get(K.src);
  if (!src || now - src.t > 30 * DAY || qs.get('gclid') || qs.get('utm_source')) {
    var s = qs.get('utm_source') || '', m = qs.get('utm_medium') || '', c = qs.get('utm_campaign') || '';
    var origin = qs.get('gclid') || qs.get('gbraid') || qs.get('wbraid') ? 'google_ads'
      : s ? (s + (m ? '/' + m : ''))
      : document.referrer && !/desayunosdelcielo/.test(document.referrer) ? (document.referrer.match(/^https?:\/\/([^/]+)/) || [, 'referral'])[1].replace(/^www\./, '')
      : (src && src.o) || 'directo';
    if (!src || qs.get('gclid') || qs.get('utm_source') || origin !== 'directo') {
      src = { o: origin, c: c, g: qs.get('gclid') || qs.get('gbraid') || qs.get('wbraid') || '', t: now };
      set(K.src, src);
    }
  }
  var originLabel = (src && src.o) || 'directo';

  /* ---------- Código corto de seguimiento (para cerrar la venta en WhatsApp y reportarla) ---------- */
  function newRef() {
    var a = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789', r = 'DC-';
    for (var i = 0; i < 4; i++) r += a[Math.floor(Math.random() * a.length)];
    return r;
  }
  var ref = get(K.ref);
  if (!ref || now - ref.t > 7 * DAY) { ref = { v: newRef(), t: now }; set(K.ref, ref); }

  /* ---------- Reglas para no molestar ---------- */
  var d = root.dataset;
  var perWeek = parseInt(d.perWeek, 10); if (isNaN(perWeek)) perWeek = 1;
  if (perWeek <= 0) return;
  var shows = (get(K.shows) || []).filter(function (t) { return now - t < 7 * DAY; });
  var clicked = get(K.clicked), closed = get(K.closed);
  if (shows.length >= perWeek) return;
  if (clicked && now - clicked < 14 * DAY) return;
  if (closed && now - closed < DAY) return;
  if (/^\/(cart|checkout|account)/.test(location.pathname)) return;

  /* ---------- Mensaje corto según la página (sin "hoy" ni códigos) ---------- */
  var co = new Date(now + (new Date().getTimezoneOffset() - 300) * 6e4);
  var h = co.getHours() + co.getMinutes() / 60;
  var product = d.product, collection = d.collection, zone = d.zone;
  var copy = {
    title: '¿No sabes cuál elegir o necesitas confirmar la entrega?',
    text: 'Te ayudamos por WhatsApp.',
    cta: 'Escribir por WhatsApp',
    msg: 'Hola, quiero hacer un pedido. ¿Me ayudan?'
  };
  if (d.exterior === 'true') {
    copy.title = '¿Estás fuera de Colombia?';
    copy.text = 'Te ayudamos a elegir y a coordinar la entrega en Bogotá por WhatsApp.';
    copy.msg = 'Hola, estoy fuera de Colombia y quiero enviar una sorpresa a Bogotá. ¿Me ayudan?';
  } else if (product) {
    copy.title = '¿Te gusta el ' + product + '?';
    copy.text = 'Te ayudamos fácil con tu pedido por WhatsApp.';
    copy.cta = 'Lo quiero';
    copy.msg = 'Hola, quiero este: ' + product + '. ¿Me ayudan con mi pedido?';
  } else if (zone) {
    copy.title = '¿Una sorpresa en ' + zone + '?';
    copy.text = 'Te ayudamos fácil con tu pedido por WhatsApp.';
    copy.msg = 'Hola, quiero enviar una sorpresa en ' + zone + '. ¿Me ayudan con mi pedido?';
  } else if (collection) {
    copy.title = '¿Buscas algo de ' + collection + '?';
    copy.text = 'Te ayudamos fácil a elegir y a hacer tu pedido por WhatsApp.';
    copy.msg = 'Hola, estoy viendo ' + collection + '. ¿Me ayudan con mi pedido?';
  }
  var statusEl = root.querySelector('[data-wapop-status]');
  if (d.exterior !== 'true' && (h >= 22 || h < 5.5)) { statusEl.textContent = 'Respondemos desde 5:30 a. m.'; statusEl.parentNode.classList.add('is-off'); }

  root.querySelector('[data-wapop-title]').textContent = copy.title;
  root.querySelector('[data-wapop-text]').textContent = copy.text;
  root.querySelector('[data-wapop-cta-label]').textContent = copy.cta;
  var cta = root.querySelector('[data-wapop-cta]');
  cta.href = 'https://wa.me/' + (d.phone || '573508603080') + '?text=' + encodeURIComponent(copy.msg);

  var variant = d.exterior === 'true' ? 'exterior' : product ? 'producto' : zone ? 'zona' : collection ? 'coleccion' : 'general';

  /* ---------- Abrir / cerrar ---------- */
  var opened = false, lastFocus = null;
  /* El configurador del producto cuenta como "abierto" si se ve en pantalla o ya pasó del paso 1. */
  function configuratorOpen() {
    var cfg = document.querySelector('ddc-configurator .ddc-config');
    if (!cfg) return false;
    if (cfg.dataset.activeStep && cfg.dataset.activeStep !== '1') return true;
    var r = cfg.getBoundingClientRect();
    return r.bottom > 0 && r.top < innerHeight && r.height > 0;
  }
  function busy() {
    var a = document.activeElement, c = document.body.classList;
    return (a && /INPUT|TEXTAREA|SELECT/.test(a.tagName)) || c.contains('ddc-gift-finder-open') || c.contains('ddc-configuring') ||
      c.contains('ddc-pgz-open') || configuratorOpen() ||
      !!document.querySelector('.ddc-gift-finder.is-open, .ddc-gift-finder[open], .ddc-cs__sheet:not([hidden])');
  }
  function open(trigger) {
    if (opened || busy() || document.querySelector('dialog[open], .drawer.active, cart-drawer.active')) return false;
    opened = true;
    shows.push(Date.now()); set(K.shows, shows);
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); document.body.classList.add('ddc-wapop-open'); });
    setTimeout(function () { try { cta.focus({ preventScroll: true }); } catch (e) {} }, 350);
    gtagEv('ddc_wa_popup_view', { disparador: trigger, variante: variant, origen_trafico: originLabel, wa_ref: ref.v });
    detach();
    return true;
  }
  function close(reason) {
    root.classList.remove('is-open'); document.body.classList.remove('ddc-wapop-open');
    setTimeout(function () { root.hidden = true; }, 300);
    if (reason !== 'click') { set(K.closed, Date.now()); gtagEv('ddc_wa_popup_close', { variante: variant, motivo: reason }); }
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  root.querySelectorAll('[data-wapop-close]').forEach(function (b) { b.addEventListener('click', function () { close(b.classList.contains('ddc-wapop__later') ? 'seguir_viendo' : 'x'); }); });
  root.addEventListener('click', function (e) { if (e.target === root) close('fondo'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened && !root.hidden) close('escape'); });
  cta.addEventListener('click', function () {
    set(K.clicked, Date.now());
    /* whatsapp_click lo envía ddc-events.js (ubicacion = data-wa-button). Aquí añadimos el detalle comercial. */
    gtagEv('ddc_wa_popup_click', { variante: variant, origen_trafico: originLabel, wa_ref: ref.v, producto: product || '', zona: zone || '' });
    close('click');
  });

  /* Cualquier clic a WhatsApp en la tienda (flotante, botones) también lleva la ref y suprime la ventana */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
    if (!a || a === cta) return;
    set(K.clicked, Date.now());
  }, true);

  /* ---------- Disparadores ---------- */
  /* Tiempo de navegación activa: solo suma con la pestaña visible y si hubo actividad en los últimos 15 s. */
  var delay = Math.max(3, parseInt(d.delay, 10) || 40) * 1000;
  var active = 0, lastAct = Date.now(), TICK = 1000, IDLE = 15000;
  var ACT = ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel'];
  function mark() { lastAct = Date.now(); }
  ACT.forEach(function (ev) { addEventListener(ev, mark, { passive: true, capture: true }); });
  var timer = setInterval(function () {
    if (document.visibilityState !== 'visible' || Date.now() - lastAct > IDLE) return;
    active += TICK;
    /* Si se cumple el tiempo pero el configurador está abierto, espera y vuelve a intentar en cada tick. */
    if (active >= delay) open('tiempo');
  }, TICK);
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - now > 5000) open('salida'); }
  if (d.exit !== 'false' && matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onExit);
  function detach() {
    clearInterval(timer);
    ACT.forEach(function (ev) { removeEventListener(ev, mark, { capture: true }); });
    document.removeEventListener('mouseout', onExit);
  }
  /* Gancho de prueba (QA): window.__ddcWaPopActive() devuelve los ms activos acumulados. */
  window.__ddcWaPopActive = function () { return active; };
})();
